module.exports = {"230707004":"黎明社区","230707005":"红建中心社区","230707006":"新民社区","230707007":"富民社区","230707008":"育林社区","230707009":"新立中心社区","230707400":"红林经营所","230707401":"松林林场","230707402":"泉林林场","230707404":"水源林场","230707405":"笑山林场","230707406":"汤林林场","230707407":"桦林经营所","230707408":"青林林场","230707409":"结源林场","230707410":"北沟林场","230707411":"南沟林场","230707412":"乌拉嘎经营所","230707413":"柳树河林场","230707414":"北影林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230707.json
// module id = 835
// module chunks = 0